// eslint-disable-next-line no-shadow
export enum PropertyType {
  Text,
  Date,
  Number,
  Currency,
}
